import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading, user, setAuthUser, isAuth, handleLogin, handleLogout,
		// feat_299 — "Ver como usuario"
		realUser, viewAsUser, activateViewAs, exitViewAs
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading, user, setAuthUser, isAuth, handleLogin, handleLogout,
				realUser, viewAsUser, activateViewAs, exitViewAs
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
